import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './Layout/Layout';
import Home from './Pages/Home/Home';
import Arena from './Pages/Arena/Arena';
import ArenaPage from './Pages/ArenaPage/ArenaPage';
import Games from './Pages/Games/Games';
import GamePage from './Pages/GamePage/GamePage';
import Contact from './Pages/Contact/Contact';
// import Gallery from './Pages/Gallery/Gallery';
import NoPage from './Pages/NoPage/NoPage';
import Legalice from './Pages/Lagalice/Lagalice';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="arenas" element={<Arena />} />
          <Route path="arenas/:id" element={<ArenaPage />} />
          <Route path="games" element={<Games />} />
          <Route path="games/:id" element={<GamePage />} />
          <Route path="contact" element={<Contact />} />
          {/* <Route path="gallery" element={<Gallery />} /> */}
          <Route path="privacy" element={<Legalice />} />
          <Route path="*" element={<NoPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
